import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { ConversationModel } from '~/models';
import { BulkPaneShell } from '../conversation/BulkPaneShell';
import { greetingScopeKey } from '../conversation/greetingScopeKey';
import { useBulkAgentPane } from '../conversation/useBulkAgentPane';
export const GetBulkDraftAgentPaneTID = (parentTestId)=>getTestIds(parentTestId);
export const BulkDraftAgentPane = (param)=>{
    let { scope, draftNames, viewSignature, onFilterUpdate, onSelectionUpdate, onScopeRestore, onChatCleared, onSellerPrompted, onDraftsChanged, onAssistantMessage, isOpen: controlledIsOpen, onOpenChange, regreetDelayMs, testId = '' } = param;
    const { BulkDraftAgentPaneTestIds } = useMemo(()=>GetBulkDraftAgentPaneTID(testId), [
        testId
    ]);
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isControlled = controlledIsOpen != null;
    const isOpen = isControlled ? controlledIsOpen : internalIsOpen;
    const setIsOpen = (open)=>{
        if (!isControlled) setInternalIsOpen(open);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
    const { api: storeApi } = useStoreActions();
    const replayedFilter = useRef(null);
    const { conversation, handlers, sendPrompt } = useBulkAgentPane(_object_spread_props(_object_spread(_object_spread_props(_object_spread({
        api: {
            get: (conversationId)=>storeApi.agenticBulkDraft.get(conversationId),
            sendMessage: (args)=>storeApi.agenticBulkDraft.sendMessage(_object_spread_props(_object_spread({}, args), {
                    scope
                })),
            undo: (args)=>storeApi.agenticBulkDraft.undo(args)
        },
        createConversation: ()=>storeApi.agenticBulkDraft.create({
                matchedDraftCount: scope.matchedDraftCount,
                draftNames,
                selectedDraftIds: scope.selectedDraftIds,
                currentFilter: scope.currentFilter
            }),
        restoreMostRecent: ()=>storeApi.agenticBulkDraft.recent(),
        onScopeRestored: (restoredScope)=>onScopeRestore === null || onScopeRestore === void 0 ? void 0 : onScopeRestore(_object_spread_props(_object_spread({}, restoredScope), {
                replayedFilter: replayedFilter.current
            })),
        sendFeedback: (args)=>storeApi.agenticBulkDraft.feedback(args),
        onAssistantMessage: handleAssistantMessage,
        onHydrated: applyPersistedUpdates,
        onEntityApplied: (draftId)=>onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged([
                draftId
            ]),
        isOpen
    }, onSellerPrompted != null ? {
        onSellerPrompted
    } : {}), {
        feedbackToastTestId: BulkDraftAgentPaneTestIds.FeedbackSuccessToast()
    }), regreetDelayMs != null ? {
        regreetDelayMs
    } : {}), {
        greetingScopeKey: greetingScopeKey({
            selectedIds: scope.selectedDraftIds,
            matchedCount: scope.matchedDraftCount,
            currentFilter: scope.currentFilter,
            viewSignature
        })
    }));
    // WHY onScopeRestore: onFilterUpdate writes the board unconditionally, wiping the seller's own scope (ANCR-5387)
    function applyPersistedUpdates(messages) {
        const restored = ConversationModel.ofMessages(messages);
        replayedFilter.current = restored.latestPersistedFilterUpdate();
        onScopeRestore === null || onScopeRestore === void 0 ? void 0 : onScopeRestore({
            currentFilter: replayedFilter.current,
            selectedDraftIds: restored.latestPersistedSelectionUpdate(),
            replayedFilter: replayedFilter.current
        });
    }
    function handleAssistantMessage(message) {
        const content = message.assistantContent();
        if (content == null) return;
        const filterUpdate = message.persistedFilterUpdate();
        switch(content.type){
            case 'bulk-confirmation':
            case 'chat-text':
            case 'sequenced-confirmation':
                if (filterUpdate != null) onFilterUpdate === null || onFilterUpdate === void 0 ? void 0 : onFilterUpdate(filterUpdate);
                if (content.selectionUpdate != null && content.selectionUpdate.length > 0) {
                    onSelectionUpdate === null || onSelectionUpdate === void 0 ? void 0 : onSelectionUpdate(content.selectionUpdate);
                }
                break;
            case 'bulk-applied':
                onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged(content.appliedIds);
                break;
            case 'reverted':
                onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged(content.revertedItemIds);
                break;
        }
        onAssistantMessage === null || onAssistantMessage === void 0 ? void 0 : onAssistantMessage(message);
    }
    return /*#__PURE__*/ _jsx(BulkPaneShell, {
        testId: BulkDraftAgentPaneTestIds.OpenPaneHeader(),
        isOpen: isOpen,
        conversation: conversation,
        handlers: handlers,
        onSubmitPrompt: sendPrompt,
        clearChatBiName: "clear_bulk_agent_chat",
        onChatCleared: onChatCleared,
        toggleBiName: "toggle_bulk_agent_pane",
        onToggle: ()=>setIsOpen(!isOpen),
        onExpand: ()=>setIsOpen(true)
    });
};
